import { render, staticRenderFns } from "./LayoutCalendar.vue?vue&type=template&id=b5ce86d6&"
import script from "./LayoutCalendar.vue?vue&type=script&lang=ts&"
export * from "./LayoutCalendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports